import { useNavigate } from 'react-router-dom';
import { Button, Input, InputWrapperAuth } from '@/components/ui';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { CircleArrowLeft, CircleQuestionMark, Mail } from 'lucide-react';
import { UserWelcomeContainer } from '@/pages/user';

const schema = z.object({
	email: z.string().max(255, 'Email inválido').email('Email inválido'),
});

type FormData = z.infer<typeof schema>;

const RecoverPassword = () => {
	const navigate = useNavigate();

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
	} = useForm<FormData>({
		resolver: zodResolver(schema),
	});

	const iconCommonClass = 'w-4 h-4 text-zinc-500';

	const onSubmit = async (data: FormData) => {
		console.log(data);
		navigate('/recuperar-senha/codigo');
	};

	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			className="flex h-full w-full flex-col items-center justify-center space-y-6 overflow-hidden overflow-y-auto px-4 py-6 md:w-1/2 md:max-w-none md:space-y-8 md:p-4"
		>
			<UserWelcomeContainer
				title="Recuperar senha"
				subtitle="Por favor, insira seu email"
			/>
			<div className="mx-auto flex w-full max-w-96 flex-col gap-4">
				<InputWrapperAuth
					label="Email"
					icon={<Mail className={iconCommonClass} />}
					error={errors.email?.message}
					value={watch('email')}
					displayError
				>
					<Input
						{...register('email')}
						placeholder="Digite seu email"
					/>
				</InputWrapperAuth>
			</div>
			<Button
				className=" w-full max-w-96 justify-center rounded-lg py-2"
				text="Enviar"
				endIcon={
					<Mail className="h-fit w-4 text-light transition-all ease-in group-hover:translate-x-1" />
				}
			/>
			<div className="mx-auto flex flex-col items-center gap-2 rounded-lg p-4 md:w-96">
				<label
					htmlFor="button-question"
					className="text-dar font-light"
				>
					Tem alguma dúvida?
				</label>
				<div className="flex items-center gap-1">
					<CircleQuestionMark className="size-4 text-cyan-950" />
					<button
						name="button-question"
						className="border-0 border-b border-solid border-cyan-950 leading-3 text-cyan-950 focus:outline-none"
					>
						Central de ajuda
					</button>
				</div>
			</div>
			<div className="mx-auto w-96">
				<Button
					startIcon={<CircleArrowLeft className="size-4 text-dark" />}
					variant="text"
					text="voltar"
					className="w-fit justify-center self-start text-base"
					onClick={() => navigate(-1)}
				/>
			</div>
		</form>
	);
};

export { RecoverPassword };
